<template>
    <div class="AutoPlay">
        <h1>
            <span class="title">Highlights</span>
            <span class="subtitle">成果展示</span>
        </h1>
        <swiper class="swiper swiper_02"
            :modules="[Autoplay]"
            :space-between="30"
            :breakpoints="{
                // 当窗口宽度 >= 320px 时，显示 2 个幻灯片
                320: { slidesPerView: 3 },
                // 当窗口宽度 >= 640px 时，显示 4 个幻灯片
                640: { slidesPerView: 5 }
            }"
            :autoplay="{delay: 3200,
                stopOnLastSlide: false,
                disableOnInteraction: false,
                reverseDirection: false}"
            :freeMode="true"
            :loop="true"
            :speed="auto">
            <swiper-slide
                v-for="(slideContent, index) in slides">
                <img style="width: auto; height: 100%; object-fit: contain; box-shadow: 1vmax 1vmax 0 0 rgba(0, 0, 255, 0.2);" :src="require('../assets/images/AutoPlay/highlights1/'+ index +'.jpg')" :alt="'highlights1-' + index"/>
            </swiper-slide>
        </swiper>
        <swiper class="swiper swiper_02"
            :modules="[Autoplay]"
            :space-between="30"
            :breakpoints="{
                // 当窗口宽度 >= 320px 时，显示 2 个幻灯片
                320: { slidesPerView: 3 },
                // 当窗口宽度 >= 640px 时，显示 4 个幻灯片
                640: { slidesPerView: 5 }
            }"
            :autoplay="{delay: 2800,
                stopOnLastSlide: false,
                disableOnInteraction: false,
                reverseDirection: false}"
            :free-mode="true"
            :loop="true"
            :speed="auto">
            <swiper-slide
                v-for="(slideContent, index) in slides">
                <img style="width: auto; height: 100%; object-fit: contain; box-shadow: 1vmax 1vmax 0 0 rgba(0, 0, 255, 0.2);" :src="require('../assets/images/AutoPlay/highlights2/'+ index +'.jpg')" :alt="'highlights2-' + index"/>
            </swiper-slide>
        </swiper>
    </div>
</template>
<script>
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css/bundle';

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        // Create array with 12 slides
        const slides = Array.from({ length: 14 }).map(
            (el, index) => `Slide ${index + 1}`
        );
        return {
            slides,
            Autoplay,
        };
    },
    onMounted() {
        initSwiper();
        console.log(this.slides);
    },
};
</script>

<style>
.AutoPlay .title {
    font-family: 'Regular';
    font-size: 3.5vmin;
    margin-top: 3vw;
    display: block;
}

.AutoPlay .subtitle {
    font-family: 'FangYuan';
    font-size: 3vmin;
    font-weight: normal;
    letter-spacing: 0.3em;
    display: block;
}

.swiper_02 .swiper-slide {
    width: auto !important;
    height: 15vmax;
    margin-right: 3vmax !important;
}

/* .swiper_02 .swiper-wrapper {
    -webkit-transition-timing-function: linear;
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
} */

.swiper_02 {
    margin: 3vw 0vw;
    height: 16vmax;
    /* 禁止选中 */
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;     /* IE 10+ */
    user-select: none;         /* 标准语法 */
}

.AutoPlay {
    color: #513890;
    margin: 6vw 0vw;
    /* background-image: url('../assets/images/Parallax/back1.png'); */
}
</style>